/**
 * 题目库分类值对象类型
 */
export interface TQuestionBankCategory {
  /**
   * 主键
   */
  readonly id?: string;

  /**
   * 父分类
   */
  pid?: string;

  /**
   * 名字
   */
  name: string;

  /**
   * 位置
   */
  readonly index?: number;
}

export interface TQuestionBankCategorySubTree extends TQuestionBankCategory {
  children?: TQuestionBankCategory[]; // 子分类是可选的，使用 ? 表示可选属性
}

export interface TQuestionBankCategoryTree {
  questionBankCategories: TQuestionBankCategory[];
}

export enum EQuestionType {
  SINGLE_CHOICE,
  MULTIPLE_CHOICE,
  TURE_OR_FALSE,
  SUBJECTIVE,
}

export const questionTypeList = [
  {
    text: '单选题',
    value: EQuestionType.SINGLE_CHOICE,
  },
  {
    text: '多选题',
    value: EQuestionType.MULTIPLE_CHOICE,
  },
  {
    text: '判断题',
    value: EQuestionType.TURE_OR_FALSE,
  },
  {
    text: '主观题',
    value: EQuestionType.SUBJECTIVE,
  },
];

export interface TQuestion {
  id?: string;
  categoryId: string;
  title?: string;
  description?: string;
  type?: EQuestionType;
  info?: TQuestionInfo;
  analysis?: string;
  enable?: number;
  createBy?: number;
  createTime?: Date;
  creator?: string;
}

export interface TQuestionInfo {
  options: TQuestionOption[];
  answer: boolean;
}

export type TQuestionOption = {
  answer: boolean;
  description: string;
  index: number;
};
